import {
  Box,
  Button,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  DialogContent,
  Dialog,
  TextField,
  Link,
} from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import styles from "./PostRequirement.module.css";
import { customTextColor } from "../../utils/const";
import profile_image from "../../assets/images/ajit_image.jpeg";
import { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import SideDrawer from "./SideDrawer";
import { LuShieldCheck } from "react-icons/lu";
import { PiUserCircleCheckFill } from "react-icons/pi";
import resume from "../../assets/images/cv.png";
import { IoSearchOutline } from "react-icons/io5";
import { IoIosSearch } from "react-icons/io";
import { PiMailboxLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { PiLinkedinLogoLight } from "react-icons/pi";
import SideIcon from "./SideIcon";
import MatchesResultPublicResume from "../../components/containers/MatchesResultPublicResume";
import { BsThreeDotsVertical } from "react-icons/bs";
import Search from "../../assets/images/search (2).png";
import { FaRegFileAlt } from "react-icons/fa";
import { CiFileOn } from "react-icons/ci";
import { PiFileTextLight } from "react-icons/pi";
import { BsSend } from "react-icons/bs";
import SideDrawers from "../InternalTracker/Candidate/SideDrawers";
import { PiMapPinSimpleLineLight } from "react-icons/pi";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { PiUserLight } from "react-icons/pi";

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const ViewCandidateDetails = () => {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showMoreExperience, setShowMoreExperience] = useState(false);

  const [oppen, setOppen] = useState(false);
  const [side, setSide] = useState(false);

  const handleCloseSide = () => setSide(false);
  const handleSide = () => setSide(true);

  const handleToggleExperience = () => {
    setShowMoreExperience(!showMoreExperience);
  };

  const handleToggle = () => {
    setShowMore(!showMore);
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [isProfileVisible, setIsProfileVisible] = useState(false);

  const handleThreeDotsClick = () => {
    setIsProfileVisible(!isProfileVisible);
  };
  const [typeResult, setTypeResult] = useState("public");

  return (
    // <RootComponents>
      <>
      <Box className={styles.search_candidate_stucture}>
        <Box className={styles.job_serach_result_heading}>
          <Typography sx={{ color: customTextColor }}>
            Candidate Details
          </Typography>
          <span onClick={handleShow}>
            <Typography sx={{ color: customTextColor }}>
              Kevin Macklin - Submission History
            </Typography>
            <IoIosArrowBack
              className={styles.arrow_icon}
              style={{ color: "rgb(147 145 145)", fontSize: "18px" }}
            />
          </span>
        </Box>

        <SideIcon handleClose={handleCloseSide} side={side} />

        <Grid container className={styles.verification_phase}>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ color: customTextColor, border: "none !important" }}
          >
            <Typography sx={{ marginLeft: "0 !important" }}>
              <b>Two Step Verification</b>{" "}
              <LuShieldCheck style={{ fontSize: "20px", color: "#54a6e6" }} />
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ color: customTextColor }}
          >
            <Typography>
              <b>Profile Active</b>

              <LuShieldCheck style={{ fontSize: "20px", color: "#54a6e6" }} />

              {/* <PiUserCircleCheckFill
                style={{ fontSize: "20px", color: "#54a6e6" }}
              /> */}
            </Typography>
          </Grid>
          {/* <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              sx={{ color: customTextColor }}
            >
              <Typography><b>Submitted on 12 May 2024</b><FaRegCheckCircle style={{ fontSize: "20px" }} /></Typography>
            </Grid> */}
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ color: customTextColor }}
          >
            <Typography>
              <b>
                <b> 95%</b>Searching Matches
              </b>
              <IoSearchOutline style={{ fontSize: "20px", color: "#54a6e6" }} />
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ color: customTextColor }}
          >
            <Typography sx={{ cursor: "pointer" }}>
              <b>Resume</b>
              <PiFileTextLight style={{ fontSize: "20px", color: "#54a6e6" }} />
            </Typography>
            <BsThreeDotsVertical
              onClick={handleThreeDotsClick}
              style={{ cursor: "pointer" }}
            />
          </Grid>
        </Grid>

        {isProfileVisible && (
          <Box className={styles.profile_and_submit}>
            <Box>
              <Typography>
                <b>Profile Uploaded By</b>
              </Typography>
              <Typography sx={{ marginTop: "10px !important" }}>
                Name: <b>Harish *****</b>
              </Typography>
              <Typography>
                Designation: <b>Sr. Recruiter</b>
              </Typography>
              <Typography>
                Profile Updated: <b>10 August 2024</b>
              </Typography>
            </Box>
            <Box
              className={styles.phase2}
              sx={{ marginTop: "20px !important" }}
            >
              <img src={Search} alt="attachment" style={{ width: "50px" }} />
              <Typography>
                <b>Search Rank 12</b>
              </Typography>
              <Typography>
                <b>ID:MM00125 | Category: Depended</b>
              </Typography>
            </Box>
          </Box>
        )}

        <Box className={styles.matches_and_submit}>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ color: customTextColor }}
            >
              <Box>
                <Typography>
                  Name : <b>Kevin Macklin</b>
                </Typography>

                <Typography>
                  Experience : <b>10 Years</b>
                </Typography>
                <Typography>
                  Current Location : <b>Dallas Taxes</b>
                </Typography>
                <Typography>
                  Organization : <b>ABC Technologies Pvt Ltd</b>
                </Typography>

                <Typography>
                  Qualifications : <b>B Tech</b>
                </Typography>
                <Typography sx={{ marginBottom: "0 !important" }}>
                  Prefer Tax Term : <b>Any</b>
                </Typography>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{
                color: customTextColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography>
                  Job Profile : <b>Lead Java Developer</b>
                </Typography>
                <Typography>
                  Work Authorization : <b> Green Card</b>
                </Typography>
                <Typography>
                  Prefer Location : <b>San Club California, CA</b>
                </Typography>
                <Typography>
                  Domain : <b>Healthcare, Retail, Banking</b>
                </Typography>
                <Typography>
                  University & Year : <b>Boston Texas,2024</b>
                </Typography>
                <Typography sx={{ marginBottom: "0 !important" }}>
                  Current Rate : <b>100$</b>
                </Typography>
              </Box>

              <Box>
                <span onClick={handleSide} style={{ cursor: "pointer" }}>
                  <Typography>
                    <div
                      style={{
                        backgroundColor: "#e1eaf0",
                        padding: "7px",
                        borderRadius: "3px",
                      }}
                    >
                      <IoIosSearch style={{ fontSize: "22px" }} />
                    </div>
                  </Typography>
                </span>
                <Typography>
                  <div
                    style={{
                      backgroundColor: "#e1eaf0",
                      padding: "7px",
                      borderRadius: "3px",
                    }}
                  >
                    <PiMailboxLight style={{ fontSize: "22px" }} />
                  </div>
                </Typography>
                <Typography>
                  <div
                    style={{
                      backgroundColor: "#e1eaf0",
                      padding: "7px",
                      borderRadius: "3px",
                    }}
                  >
                    <CiMobile3 style={{ fontSize: "22px" }} />
                  </div>
                </Typography>
                <Typography>
                  <div
                    style={{
                      backgroundColor: "#e1eaf0",
                      padding: "7px",
                      borderRadius: "3px",
                    }}
                  >
                    <PiLinkedinLogoLight style={{ fontSize: "22px" }} />
                  </div>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box className={styles.primary_details}>
          <Typography sx={{ marginBottom: "20px !important" }}>
            <b> Primary skills</b>
          </Typography>

          <Grid container sx={{ fontweight: "600" }}>
            <Grid item xs={6} sm={6} md={2.3} lg={2.3}>
              <Box sx={{ color: customTextColor }}>
                <ul
                  style={{
                    listStyleType: "square",
                    padding: "5px 20px",
                    marginBottom: "10px",
                  }}
                >
                  <Box>
                    <li>
                      <Typography>Hibernate </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>Spring Boot </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>MVC Frame Work</Typography>
                    </li>
                  </Box>
                </ul>
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={3.5}
              lg={3.5}
              sx={{
                position: "relative",
                paddingLeft: "20px",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "5%",
                  bottom: "15%",
                  width: "1.5px",
                  backgroundColor: "#cac6c6",
                },
              }}
            >
              <Box sx={{ color: customTextColor }}>
                <ul
                  style={{
                    listStyleType: "square",
                    padding: "5px 20px",
                    marginBottom: "10px",
                  }}
                >
                  <Box>
                    <li>
                      <Typography>Hibernate</Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>Spring Boot</Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>MVC Frame Work</Typography>
                    </li>
                  </Box>
                </ul>
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={3.1}
              lg={3.1}
              sx={{
                position: "relative",
                paddingLeft: "20px",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "5%",
                  bottom: "15%",
                  width: "2px",
                  backgroundColor: "#cac6c6",
                },
              }}
            >
              <Box sx={{ color: customTextColor }}>
                <ul
                  style={{
                    listStyleType: "square",
                    padding: "5px 20px",
                    marginBottom: "10px",
                  }}
                >
                  <Box>
                    <li>
                      <Typography>Hibernate </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>Spring Boot </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>MVC Frame Work</Typography>
                    </li>
                  </Box>
                </ul>
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={3.1}
              lg={3.1}
              sx={{
                position: "relative",
                paddingLeft: "20px",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "5%",
                  bottom: "15%",
                  width: "2px",
                  backgroundColor: "#cac6c6",
                },
              }}
            >
              <Box sx={{ color: customTextColor }}>
                <ul
                  style={{
                    listStyleType: "square",
                    padding: "5px 20px",
                    marginBottom: "10px",
                  }}
                >
                  <Box>
                    <li>
                      <Typography>Hibernate </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>Spring Boot </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>MVC Frame Work</Typography>
                    </li>
                  </Box>
                </ul>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box className={styles.list_details}>
          <Typography sx={{ marginBottom: "20px !important" }}>
            <b> Secondary skills</b>
          </Typography>

          <Grid container sx={{ fontweight: "600" }}>
            <Grid item xs={6} sm={6} md={2.3} lg={2.3}>
              <Box sx={{ color: customTextColor }}>
                <ul
                  style={{
                    listStyleType: "square",
                    padding: "5px 20px",
                    marginBottom: "10px",
                  }}
                >
                  <Box>
                    <li>
                      <Typography>Hibernate </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>Spring Boot </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>MVC Frame Work</Typography>
                    </li>
                  </Box>
                </ul>
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={3.5}
              lg={3.5}
              sx={{
                position: "relative",
                paddingLeft: "20px",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "5%",
                  bottom: "15%",
                  width: "1.5px",
                  backgroundColor: "#cac6c6",
                },
              }}
            >
              <Box sx={{ color: customTextColor }}>
                <ul
                  style={{
                    listStyleType: "square",
                    padding: "5px 20px",
                    marginBottom: "10px",
                  }}
                >
                  <Box>
                    <li>
                      <Typography>Hibernate</Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>Spring Boot</Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>MVC Frame Work</Typography>
                    </li>
                  </Box>
                </ul>
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={3.1}
              lg={3.1}
              sx={{
                position: "relative",
                paddingLeft: "20px",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "5%",
                  bottom: "15%",
                  width: "2px",
                  backgroundColor: "#cac6c6",
                },
              }}
            >
              <Box sx={{ color: customTextColor }}>
                <ul
                  style={{
                    listStyleType: "square",
                    padding: "5px 20px",
                    marginBottom: "10px",
                  }}
                >
                  <Box>
                    <li>
                      <Typography>Hibernate </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>Spring Boot </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>MVC Frame Work</Typography>
                    </li>
                  </Box>
                </ul>
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={3.1}
              lg={3.1}
              sx={{
                position: "relative",
                paddingLeft: "20px",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "5%",
                  bottom: "15%",
                  width: "2px",
                  backgroundColor: "#cac6c6",
                },
              }}
            >
              <Box sx={{ color: customTextColor }}>
                <ul
                  style={{
                    listStyleType: "square",
                    padding: "5px 20px",
                    marginBottom: "10px",
                  }}
                >
                  <Box>
                    <li>
                      <Typography>Hibernate </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>Spring Boot </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>MVC Frame Work</Typography>
                    </li>
                  </Box>
                </ul>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <div>
          <Typography
            className={styles.add_heading}
            onClick={handleToggleExperience}
            style={{ cursor: "pointer" }}
          >
            <b>
              {showMoreExperience
                ? "View 2 More Experience"
                : "View 2 More Experience"}
            </b>
          </Typography>

          {showMoreExperience && (
            <>
              <>
                {isEditing ? (
                  // Editable Form

                  <Grid container className={styles.candidate_field_section}>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                    >
                      <Box className={styles.icon_style}>
                        <PiUserLight style={{ fontSize: "25px" }} />
                      </Box>
                      <TextField
                        id="standard-basic"
                        label="Role"
                        variant="standard"
                        name="full_name"
                        sx={fieldStyle}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                    >
                      <Box
                        className={styles.icon_style}
                        sx={{ transform: "translateY(-50%) !important" }}
                      >
                        <PiBuildingOfficeLight style={{ fontSize: "25px" }} />
                      </Box>
                      <TextField
                        id="standard-basic"
                        label="Organization"
                        variant="standard"
                        type="text"
                        name="organization"
                        sx={fieldStyle}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                    >
                      <Box className={styles.icon_style}>
                        <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
                      </Box>
                      <TextField
                        id="standard-basic"
                        label="Location"
                        variant="standard"
                        type="text"
                        name="location"
                        sx={fieldStyle}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                    >
                      <Box className={styles.icon_style}>
                        <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
                      </Box>
                      <TextField
                        id="standard-basic"
                        label="Duration"
                        variant="standard"
                        type="text"
                        name="duration"
                        sx={fieldStyle}
                      />
                    </Grid>
                  </Grid>
                ) : (
                  <>
                    <Box className={styles.text_section}>
                      <Box>
                        <Typography sx={{ marginBottom: "0 !important" }}>
                          <b>Full Stack Java Developer at Master Card Inc</b>
                        </Typography>
                        <Typography
                          sx={{
                            marginBottom: "0 !important",
                            color: "#949191 !important",
                          }}
                        >
                          May 2020 - Jan 2024 3 Years 10 Months
                        </Typography>
                        <Typography
                          sx={{
                            marginBottom: "0 !important",
                            color: "#949191 !important",
                          }}
                        >
                          Holtsville, NY
                        </Typography>
                      </Box>

                      <div>
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <img
                            src=""
                            alt=""
                            width="60px"
                            height="auto"
                          />
                        </Box>
                      </div>
                    </Box>
                  </>
                )}
              </>

              <Box className={styles.response_section}>
                <Box>
                  <Typography>
                    <b> Responsibilities</b>{" "}
                  </Typography>
                  <Typography sx={{ marginBottom: "0 !important" }}>
                    {showMore ? (
                      <>
                        Povital provides a highly recommended AI-powered search
                        engine that helps to get appropriate talent as per the
                        job requirements along with many AI filtrations behind
                        the requirement. Povital also offers manual searching
                        according to user preferences with a super easy and
                        user-friendly interface Povital also offers manual
                        searching according to user preferences with a super
                        easy and user-friendly interface
                        <Link
                          className={styles.view_show_link}
                          onClick={handleToggle}
                        >
                          Show less
                        </Link>
                      </>
                    ) : (
                      <>
                        Povital provides a highly recommended AI-powered search
                        engine that helps to get appropriate talent as per the
                        job requirements along with many AI filtrations behind
                        the requirement. Povital also offers manual searching
                        according to user preferences with a super easy and
                        user-friendly interface
                        <Link
                          className={styles.view_show_link}
                          onClick={handleToggle}
                        >
                          Show more
                        </Link>
                      </>
                    )}
                  </Typography>
                </Box>
              </Box>

              <>
                {isEdit ? (
                  <Grid container className={styles.candidate_field_section}>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                    >
                      <Box className={styles.icon_style}>
                        <PiUserLight style={{ fontSize: "25px" }} />
                      </Box>
                      <TextField
                        id="standard-basic"
                        label="Role"
                        variant="standard"
                        name="full_name"
                        sx={fieldStyle}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                    >
                      <Box
                        className={styles.icon_style}
                        sx={{ transform: "translateY(-50%) !important" }}
                      >
                        <PiBuildingOfficeLight style={{ fontSize: "25px" }} />
                      </Box>
                      <TextField
                        id="standard-basic"
                        label="Organization"
                        variant="standard"
                        type="text"
                        name="organization"
                        sx={fieldStyle}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                    >
                      <Box className={styles.icon_style}>
                        <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
                      </Box>
                      <TextField
                        id="standard-basic"
                        label="Location"
                        variant="standard"
                        type="text"
                        name="location"
                        sx={fieldStyle}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      sx={{ padding: "5px 10px 0 10px", position: "relative" }}
                    >
                      <Box className={styles.icon_style}>
                        <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
                      </Box>
                      <TextField
                        id="standard-basic"
                        label="Duration"
                        variant="standard"
                        type="text"
                        name="duration"
                        sx={fieldStyle}
                      />
                    </Grid>
                  </Grid>
                ) : (
                  <>
                    <Box className={styles.text_section}>
                      <Box>
                        <Typography sx={{ marginBottom: "0 !important" }}>
                          <b>Full Stack Java Developer at Master Card Inc</b>
                        </Typography>
                        <Typography
                          sx={{
                            marginBottom: "0 !important",
                            color: "#949191 !important",
                          }}
                        >
                          Aug 2017- Jan 2020 3 Years 4 Months
                        </Typography>
                        <Typography
                          sx={{
                            marginBottom: "0 !important",
                            color: "#949191 !important",
                          }}
                        >
                          Mortilecity, NY,
                        </Typography>
                      </Box>

                      <div>
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <img
                            src=""
                            alt=""
                            width="60px"
                            height="auto"
                          />
                        </Box>
                      </div>
                    </Box>
                  </>
                )}
              </>
              <Box className={styles.response_section}>
                <Box>
                  <Typography>
                    <b> Responsibilities</b>{" "}
                  </Typography>
                  <Typography sx={{ marginBottom: "0 !important" }}>
                    {showMore ? (
                      <>
                        Povital provides a highly recommended AI-powered search
                        engine that helps to get appropriate talent as per the
                        job requirements along with many AI filtrations behind
                        the requirement. Povital also offers manual searching
                        according to user preferences with a super easy and
                        user-friendly interface Povital also offers manual
                        searching according to user preferences with a super
                        easy and user-friendly interface
                        <Link
                          className={styles.view_show_link}
                          onClick={handleToggle}
                        >
                          Show less
                        </Link>
                      </>
                    ) : (
                      <>
                        Povital provides a highly recommended AI-powered search
                        engine that helps to get appropriate talent as per the
                        job requirements along with many AI filtrations behind
                        the requirement. Povital also offers manual searching
                        according to user preferences with a super easy and
                        user-friendly interface
                        <Link
                          className={styles.view_show_link}
                          onClick={handleToggle}
                        >
                          Show more
                        </Link>
                      </>
                    )}
                  </Typography>
                </Box>
              </Box>
            </>
          )}
        </div>

        {/* <Grid container sx={{ backgroundColor: "#fff", }}>
          <Grid item xs={6} sm={6} md={10} lg={10} >
            <Box className={styles.list_details} >
              <Typography sx={{ marginBottom: "20px !important" }}>
                Excellency in skills
              </Typography>
              <Grid container sx={{ fontweight: "600" }}>
                <Grid item xs={6} sm={6} md={2.3} lg={2.3}>
                  <Box sx={{ color: customTextColor }}>
                    <Typography>Hibernate 2 Years </Typography>
                    <Typography>Spring Boot 4 Years</Typography>
                    <Typography>Hibernate 2 Years</Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3.5}
                  lg={3.5}
                  sx={{ borderLeft: "2px solid white", paddingLeft: "20px" }}
                >
                  <Box sx={{ color: customTextColor }}>
                    <Typography> MVC 1 Years</Typography>
                    <Typography>Spring Boot 4 Years</Typography>
                    <Typography>MVC 1 Years </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3.1}
                  lg={3.1}
                  sx={{ borderLeft: "2px solid white", paddingLeft: "20px" }}
                >
                  <Box sx={{ color: customTextColor }}>
                    <Typography> Golang 2 Years </Typography>
                    <Typography>Spring Boot 4 Years</Typography>
                    <Typography>Golang 2 Years </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3.1}
                  lg={3.1}
                  sx={{ borderLeft: "2px solid white", paddingLeft: "20px" }}
                >
                  <Box sx={{ color: customTextColor }}>
                    <Typography> Hibernate 2 Years </Typography>
                    <Typography>Spring Boot 4 Years </Typography>
                    <Typography>Hibernate 2 Years</Typography>
                  </Box>

                </Grid>
              </Grid>

            </Box>
          </Grid>

          <Grid item xs={6} sm={6} md={2} lg={2}>
            <Box className={styles.add_back_btns}>
              <button
                onClick={handleClickOpen}
                style={{
                  backgroundColor: "#4285f4",
                }}
              >
                Requirements
                <BsSend style={{ marginLeft: '5px' }} />
              </button>
            </Box>
          </Grid>
        </Grid> */}
        {/*         
        <Box className={styles.profile_status_details_btns}>
          <img src={profile_image} alt="" />

          <Box className={styles.add_back_btns}>
            <button
              style={{
                backgroundColor: "#2e75b6",
                marginRight: "350px",
              }}
            >
              View Contact
            </button>

            <Box>
              <button
                onClick={handleClickOpen}
                style={{
                  backgroundColor: "#00b050",
                  marginLeft: "150px",
                }}
              >
                Send Requirement
              </button>
            </Box>
         
          </Box>
        </Box> */}

        <SideDrawer
          handleShow={handleShow}
          handleClose={handleCloseShow}
          show={show}
        />
      </Box>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        fullWidth={true}
      >
        <DialogContent>
          <Box className={styles.upload_resume_section}>
            <Box style={{ color: customTextColor }}>
              <Typography>
                <b>Available Credit</b>{" "}
              </Typography>
              <Typography sx={{ fontSize: "25px !important" }}>
                <b>1250</b>
              </Typography>
              <button>Add More Credit</button>
            </Box>
            <img src={profile_image} alt="" />
          </Box>
          <Box sx={{ margin: "10px" }}>
            <Typography>
              <b>
                {" "}
                50% credit will be reverse after respond from respective
                candidate.
              </b>
            </Typography>
          </Box>
          <Grid container className={styles.internal_details_field}>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 20px 10px 0" }}
            >
              <Typography>
                <b>Kevin Macklin </b>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 0 10px 20px" }}
            >
              <Typography>
                <b> Lead Java Developer</b>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 20px 10px 0" }}
            >
              <Typography>
                <b>Green Card</b>{" "}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 0 10px 20px" }}
            >
              <Typography>
                <b>Dallas Taxes</b>{" "}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 20px 10px 0" }}
            >
              <Typography>
                <b>Current Company: General Motors </b>{" "}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 0 10px 20px" }}
            >
              <Typography>
                <b>Client Name: Need to enter manually</b>
              </Typography>
            </Grid>
          </Grid>
          <Box className={styles.request_submit}>
            <button onClick={handleClose}>Request to Submit</button>
          </Box>
        </DialogContent>
      </Dialog>

      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        sx={{ padding: "5px 14px 10px 14px" }}
      >
        <Box className={styles.second_resume}>
          <Typography
            onClick={() => setTypeResult("public")}
            sx={
              typeResult === "public"
                ? { color: "black" }
                : { color: customTextColor }
            }
          >
            120 Similar Results
          </Typography>
          {/* <Typography
            onClick={() => setTypeResult("internal")}
            sx={
              typeResult === "internal"
                ? { color: "#95cb6d" }
                : { color: customTextColor }
            }
          >
            Internal Resume
          </Typography> */}
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        sx={{ padding: "10px 20px 10px 20px" }}
      >
        {typeResult === "public" ? (
          <>
            <MatchesResultPublicResume
              name="Himanshu Sekhar"
              job="Lead Java Developer"
              location="Noida Delhi, DL"
              salary="Rs 30k PM"
              skills="Hibernate 2 Years | Spring Boot 4 Years | AWS Cloud 2 Years | GO 2 Years"
              btn1="View Profile"
              btn2="Send E-Mail"
              matches="Matches 97%"
            />
            <MatchesResultPublicResume
              name="Pratik Reddy"
              job="Lead Java Developer"
              location="Kolkata, KK"
              salary="Rs 25k PM"
              skills="Hibernate 2 Years | Spring Boot 4 Years | AWS Cloud 2 Years | GO 2 Years"
              btn1="View Profile"
              btn2="Send E-Mail"
              matches="Matches 95%"
            />
            <MatchesResultPublicResume
              name="Rasmi Ranjan Reddy"
              job="Lead Java Developer"
              location="Kolkata, KK"
              salary="Rs 22k PM"
              skills="Hibernate 2 Years | Spring Boot 4 Years | AWS Cloud 2 Years | GO 2 Years"
              btn1="View Profile"
              btn2="Send E-Mail"
              matches="Matches 90%"
            />
          </>
        ) : (
          <></>
        )}
      </Grid>

      <Box className={styles.select_search_result_btns}>
        <button style={{ alignSelf: "flex-end " }}>Select All</button>
      </Box>

      <SideDrawers
        handleShow={handleShow}
        handleClose={handleCloseShow}
        show={show}
      />
      </>
    // </RootComponents>
  );
};

export default ViewCandidateDetails;
